import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { css, cx } from "emotion";
import { formatCurrency } from "../../components/Utils/Currency";
import moment from "moment-timezone";
import Skeleton from "@material-ui/lab/Skeleton";
import ModalUpload from "./parts/ModalUpload";
import WarningIcon from "@material-ui/icons/Warning";
import ReconciliationStore from "../../Store/ReconciliationStore";
import EditIcon from "@material-ui/icons/Edit";
import CachedIcon from "@material-ui/icons/Cached";
import DrawerHistory from "./parts/DrawerHistory";
import History from "../../History/History";
import ReconciliationService from "../../Services/ReconciliationService";
import { handleError } from "../../components/Utils/Utils";

const RekonsiliasiResult = (props) => {
  const { id } = props.match.params;
  const [reconciliationState, reconciliationActions] = ReconciliationStore();
  const [modal, setModal] = React.useState(false);
  const [downloading, setDownloading] = React.useState(false);
  const [hiddenSidebar, setHiddenSidebar] = React.useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const [resultDiv, setResultDiv] = React.useState({
    width: 0,
    left: 0,
  });

  const resultDivRef = React.useCallback((node) => {
    if (node !== null) {
      setResultDiv({
        width: node.getBoundingClientRect().width,
        left: node.getBoundingClientRect().left,
      });
    }
  }, []);

  const getDetailReconciliation = (id) => {
    reconciliationActions.getDetailReconciliation(id);
  };

  const handleReconciliationDone = (id) => {
    toggle();
    History.push(`/rekonsiliasi/result/${id}`);
    getDetailReconciliation(id);
  };

  const handleClickHistory = (id) => {
    History.push(`/rekonsiliasi/result/${id}`);
    getDetailReconciliation(id);
  };

  const handleDownloadReconciliationTransaction = (id) => {
    setDownloading(true);
    ReconciliationService.downloadReconcialitionTransaction(id)
      .then((response) => {
        setDownloading(false);
        const data = response.data;
        var temp =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          encodeURIComponent(data.content);
        var download = document.createElement("a");
        download.href = temp;
        download.download = data.file_name;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
      })
      .catch((error) => {
        setDownloading(false);
        handleError(error);
      });
  };

  const handleToggleDrawer = (value) => {
    setHiddenSidebar(value);
  }

  React.useEffect(() => {
    getDetailReconciliation(id);
  }, []);

  return (
    <BaseLayout background="gray" onToggleDrawer={handleToggleDrawer}>
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <div className="d-flex justify-content-between align-items-center">
            <button
              type="button"
              className="btn d-flex mr-auto"
              onClick={() => {
                History.push(`/rekonsiliasi`);
              }}
            >
              <ArrowBackIcon />
              <h3 className="font-16 font-bold mb-0 ml-2">
                Hasil Rekonsiliasi
              </h3>
            </button>
            <div className="d-none d-sm-block">
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-12 font-bold"
                onClick={toggle}
              >
                <CachedIcon className="mr-2" />
                New Upload
              </button>
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-12 font-bold"
                disabled={downloading}
                onClick={() => handleDownloadReconciliationTransaction(id)}
              >
                {!downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Download Laporan
                  </>
                )}

                {downloading && (
                  <>
                    <GetAppIcon className="mr-2" />
                    Proses Download
                  </>
                )}
              </button>
              <DrawerHistory
                anchor="right"
                onClickHistory={(id) => handleClickHistory(id)}
              />
            </div>
          </div>
          <div className="w-100 d-block d-sm-none mt-3">
            <div className="d-flex justify-content-start align-items-center">
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-12 font-bold"
                onClick={toggle}
              >
                <CachedIcon className="mr-2" />
                New Upload
              </button>
              <button
                type="button"
                className="btn bg-white text-primary mr-2 rounded-8px border-gray-300 font-12 font-bold"
              >
                <GetAppIcon className="mr-2" />
                Download Laporan
              </button>
              <DrawerHistory
                anchor="right"
                onClickHistory={(id) => handleClickHistory(id)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row w-100 mx-0 d-flex justify-content-center align-items-start mt-3">
        <div className="col-md-1 col-xs-12 px-0 mb-2 mb-md-0 d-flex flex-column justify-content-start align-items-center">
          <div
            ref={resultDivRef}
            className="w-100 rounded-8px bg-white text-center py-3 px-2 cursor-pointer"
            onClick={() => {
              History.push(`/rekonsiliasi/failed`);
            }}
          >
            <span className="font-10 text-secondary d-block">Result</span>
            <span className="font-13 font-bold text-danger d-flex justify-content-center align-items-center mt-2">
              {reconciliationState?.isLoadingResult && <Skeleton width="30%" />}
              {!reconciliationState?.isLoadingResult &&
                (reconciliationState?.reconciliation?.reconciliation_failed ||
                  0)}
            </span>
            <span className="font-13 text-danger d-block">No Match</span>
          </div>
        </div>
        <div className="col-md-11 col-xs-12 pl-md-3 pl-0">
          <div className="row">
            <div className="col-md-6 col-xs-12 pr-0 mb-2 mb-md-0">
              <div className="panel panel-body rounded-8px bg-white p-3 h-100">
                <div className="d-flex justify-content-start align-items-center">
                  <div className="mr-auto">
                    <span className="font-10 text-secondary">Data dari</span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">IZY</h6>
                  </div>
                  <div className="mr-2">
                    <span className="font-10 text-secondary">
                      Total transaksi
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {formatCurrency(
                        process.env.REACT_APP_CURRENCY_CODE,
                        (
                          reconciliationState?.reconciliation
                            ?.reconciliation_total_trx?.izy || 0
                        ).toString(),
                        true
                      )}
                    </h6>
                  </div>
                  <div>
                    <span className="font-10 text-secondary">
                      Total nominal
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {formatCurrency(
                        process.env.REACT_APP_CURRENCY_CODE,
                        (
                          reconciliationState?.reconciliation
                            ?.reconciliation_total_amount?.izy || 0
                        ).toString()
                      )}
                    </h6>
                  </div>
                </div>
                <div className="mt-3 table-responsive">
                  <table className="table">
                    <thead>
                      <tr
                        className={css`
                          th {
                            background-color: #eeeeee;
                            color: #212121;
                            font-size: 10px;
                            border: none;
                            padding: 13px;
                          }
                        `}
                      >
                        <th width="10%">No</th>
                        <th width="25%">Tanggal Trx</th>
                        <th width="35%">Nomor Trx</th>
                        <th width="30%">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody
                      className={css`
                        tr td {
                          color: #212121;
                          font-size: 10px;
                          padding: 10px;
                          border: none;
                          height: 40px;
                          vertical-align: middle;
                        }

                        tr {
                          border-top: 1px solid #dee2e6 !important;
                        }

                        tr.error {
                          background-color: #ffcdd2;
                        }
                      `}
                    >
                      {!reconciliationState?.isLoadingResult &&
                        reconciliationState?.reconciliation?.reconciliation_result?.map(
                          (v, k) => {
                            return (
                              <tr
                                key={k}
                                className={
                                  !v.izy_status || !v.external_status
                                    ? `error`
                                    : ``
                                }
                              >
                                <td
                                  width="10%"
                                  align="center"
                                  className={cx(
                                    css`
                                      padding-left: 50% !important;
                                    `,
                                    "d-flex justify-content-center align-items-center"
                                  )}
                                >
                                  {v.izy_status && v.external_status && (
                                    <div
                                      className={css`
                                        padding: 8px 13px;
                                        border-radius: 8px;
                                        background-color: #4caf50;
                                        font-size: 8px;
                                        font-weight: bold;
                                        color: #ffffff;
                                        width: ${!hiddenSidebar ? resultDiv.width : (resultDiv.width - 16)}px;
                                        text-align: center;
                                        position: absolute;
                                        left: -${!hiddenSidebar ? resultDiv.width : (resultDiv.width - 16)}px;
                                      `}
                                    >
                                      Match
                                    </div>
                                  )}

                                  {(!v.izy_status || !v.external_status) && (
                                    <div
                                      className={css`
                                        padding: 8px 13px;
                                        border-radius: 8px;
                                        background-color: #f44336;
                                        font-size: 8px;
                                        font-weight: bold;
                                        color: #ffffff;
                                        width: ${!hiddenSidebar ? resultDiv.width : (resultDiv.width - 16)}px;
                                        text-align: center;
                                        position: absolute;
                                        left: -${!hiddenSidebar ? resultDiv.width : (resultDiv.width - 16)}px;
                                      `}
                                    >
                                      Unmatch
                                    </div>
                                  )}
                                  <div>{k + 1}</div>
                                </td>
                                <td width="25%">
                                  {moment(v.izy_date).format("DD/MM/YYYY")}
                                </td>
                                <td width="35%">
                                  {!v.izy_status && v.izy_reference === "" && (
                                    <React.Fragment>
                                      {v.external_note}
                                      <span className="text-danger position-absolute">
                                        <WarningIcon
                                          style={{ fontSize: 16 }}
                                          className="ml-2"
                                        />
                                      </span>
                                    </React.Fragment>
                                  )}

                                  {(v.izy_status || v.izy_reference !== "") &&
                                    v.izy_reference}
                                </td>
                                <td
                                  width="30%"
                                  className={cx(
                                    "w-100 d-flex justify-content-between align-items-center"
                                  )}
                                >
                                  <span>
                                    {formatCurrency(
                                      process.env.REACT_APP_CURRENCY_CODE,
                                      (v.izy_amount || 0).toString()
                                    )}
                                    {!v.izy_status &&
                                      v.izy_amount !== v.external_amount &&
                                      v.izy_reference !== "" && (
                                        <span className="text-danger position-absolute">
                                          <WarningIcon
                                            style={{ fontSize: 16 }}
                                            className="ml-2"
                                          />
                                        </span>
                                      )}
                                  </span>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      {reconciliationState?.isLoadingResult &&
                        Array.from(new Array(5)).map((value, key) => {
                          return (
                            <tr key={key}>
                              <td width="10%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="25%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="35%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="30%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pr-0 mb-2 mb-md-0">
              <div className="panel panel-body rounded-8px bg-white p-3 h-100">
                <div className="d-flex justify-content-start align-items-center">
                  <div className="mr-auto">
                    <span className="font-10 text-secondary">Data dari</span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {reconciliationState?.reconciliation?.file_url
                        ?.split("/")
                        .pop()}
                    </h6>
                  </div>
                  <div className="mr-2">
                    <span className="font-10 text-secondary">
                      Total transaksi
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {formatCurrency(
                        process.env.REACT_APP_CURRENCY_CODE,
                        (
                          reconciliationState?.reconciliation
                            ?.reconciliation_total_trx?.external || 0
                        ).toString(),
                        true
                      )}
                    </h6>
                  </div>
                  <div>
                    <span className="font-10 text-secondary">
                      Total nominal
                    </span>
                    <br />
                    <h6 className="font-bold font-13 text-primary">
                      {formatCurrency(
                        process.env.REACT_APP_CURRENCY_CODE,
                        (
                          reconciliationState?.reconciliation
                            ?.reconciliation_total_amount?.external || 0
                        ).toString()
                      )}
                    </h6>
                  </div>
                </div>
                <div className="mt-3 table-responsive">
                  <table className="table">
                    <thead>
                      <tr
                        className={css`
                          th {
                            background-color: #eeeeee;
                            color: #212121;
                            font-size: 10px;
                            border: none;
                            padding: 13px;
                          }
                        `}
                      >
                        <th width="10%">No</th>
                        <th width="25%">Tanggal Trx</th>
                        <th width="35%">Nomor Trx</th>
                        <th width="30%">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody
                      className={css`
                        tr td {
                          color: #212121;
                          font-size: 10px;
                          padding: 10px;
                          border: none;
                          height: 40px;
                          vertical-align: middle;
                        }

                        tr {
                          border-top: 1px solid #dee2e6 !important;
                        }

                        tr.error {
                          background-color: #ffcdd2;
                        }
                      `}
                    >
                      {!reconciliationState?.isLoadingResult &&
                        reconciliationState?.reconciliation?.reconciliation_result?.map(
                          (v, k) => {
                            return (
                              <tr
                                key={k}
                                className={
                                  !v.external_status || !v.izy_status
                                    ? `error`
                                    : ``
                                }
                              >
                                <td width="10%" align="center">
                                  {k + 1}
                                </td>
                                <td width="25%">
                                  {moment(v.external_date).format("DD/MM/YYYY")}
                                </td>
                                <td width="35%">
                                  {v.external_reference || ""}
                                  {!v.external_status &&
                                    v.izy_reference === "" && (
                                      <span className="text-danger position-absolute">
                                        <WarningIcon
                                          style={{ fontSize: 16 }}
                                          className="ml-2"
                                        />
                                      </span>
                                    )}
                                </td>
                                <td
                                  width="30%"
                                  className={cx(
                                    "w-100 d-flex justify-content-between align-items-center"
                                  )}
                                >
                                  <span>
                                    {formatCurrency(
                                      process.env.REACT_APP_CURRENCY_CODE,
                                      (v.external_amount || 0).toString()
                                    )}
                                    {!v.external_status &&
                                      v.izy_amount !== v.external_amount &&
                                      v.izy_reference !== "" && (
                                        <span className="text-danger position-absolute">
                                          <WarningIcon
                                            style={{ fontSize: 16 }}
                                            className="ml-2"
                                          />
                                        </span>
                                      )}
                                  </span>
                                  {(!v.external_status || !v.izy_status) && (
                                    <button
                                      className={css`
                                        border: none;
                                        background-color: transparent;
                                        height: 100%;
                                      `}
                                    >
                                      <EditIcon style={{ fontSize: 16 }} />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      {reconciliationState?.isLoadingResult &&
                        Array.from(new Array(5)).map((value, key) => {
                          return (
                            <tr key={key}>
                              <td width="10%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="25%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="35%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                              <td width="30%">
                                <Skeleton variant="text" animation="wave" />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalUpload
        modal={modal}
        toggle={toggle}
        onReconciliationDone={(id) => handleReconciliationDone(id)}
      />
    </BaseLayout>
  );
};

export default RekonsiliasiResult;
